document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(() => {
  const cfg = window.UndeadTheme || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cfg.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const sizedImage = (url, width = 220) => {
    if (!url) return '';
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}`;
  };

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const format = cfg.moneyFormat || '${{amount}}';
    const replacements = {
      '{{amount}}': amount.toFixed(2),
      '{{amount_no_decimals}}': Math.round(amount).toString(),
      '{{amount_with_comma_separator}}': amount.toFixed(2).replace('.', ','),
      '{{amount_no_decimals_with_comma_separator}}': Math.round(amount).toString()
    };
    let result = format;
    Object.entries(replacements).forEach(([token, value]) => { result = result.replace(token, value); });
    return result;
  };

  const lockBody = () => document.body.classList.add('is-locked');
  const unlockBody = () => {
    if (!document.querySelector('.search-overlay.is-open,.cart-overlay.is-open,.product-lightbox.is-open,.wishlist-overlay.is-open,.quick-view-overlay.is-open')) document.body.classList.remove('is-locked');
  };

  const toggleLayer = (layer, open) => {
    if (!layer) return;
    layer.classList.toggle('is-open', open);
    layer.setAttribute('aria-hidden', String(!open));
    open ? lockBody() : unlockBody();
  };

  const showToast = (message) => {
    const toast = $('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  const searchOverlay = $('[data-search-overlay]');
  const searchInput = $('[data-predictive-input]');
  const predictiveResults = $('[data-predictive-results]');
  let searchTimer;

  $$('[data-search-open]').forEach((button) => button.addEventListener('click', () => {
    toggleLayer(searchOverlay, true);
    setTimeout(() => searchInput && searchInput.focus(), 180);
  }));
  $$('[data-search-close]').forEach((button) => button.addEventListener('click', () => toggleLayer(searchOverlay, false)));

  const renderPredictive = (products, query) => {
    if (!predictiveResults) return;
    if (!products.length) {
      predictiveResults.innerHTML = `<div class="predictive-results__empty"><span class="micro-label">No matches yet</span><p class="muted">Try a set name, card name, product type, or a shorter search.</p><a class="text-link" href="${escapeHtml(cfg.searchUrl || '/search')}?type=product&q=${encodeURIComponent(query)}">Search the full catalog →</a></div>`;
      return;
    }
    predictiveResults.innerHTML = `<div class="predictive-list">${products.slice(0, 8).map((product) => {
      const image = product.featured_image && product.featured_image.url ? product.featured_image.url : '';
      const type = product.type || product.product_type || 'Product';
      return `<a class="predictive-item" href="${escapeHtml(product.url)}"><span class="predictive-item__image">${image ? `<img src="${escapeHtml(image)}" alt="">` : ''}</span><span><strong>${escapeHtml(product.title)}</strong><small>${escapeHtml(type)}</small></span></a>`;
    }).join('')}</div>`;
  };

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const query = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (query.length < 2) return;
      if (predictiveResults) predictiveResults.innerHTML = '<div class="predictive-loading">Searching the catalog…</div>';
      searchTimer = setTimeout(async () => {
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;
          const response = await fetch(url, {headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Search request failed');
          const data = await response.json();
          renderPredictive((data.resources && data.resources.results && data.resources.results.products) || [], query);
        } catch (error) {
          if (predictiveResults) predictiveResults.innerHTML = '<div class="predictive-loading">Search is temporarily unavailable. Submit the search to continue.</div>';
        }
      }, 160);
    });
  }

  const mobileButton = $('[data-mobile-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (mobileButton && mobileMenu) {
    mobileButton.addEventListener('click', () => {
      const open = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', String(!open));
      mobileButton.setAttribute('aria-expanded', String(open));
    });
  }

  const navDropdown = $('[data-nav-dropdown]');
  const navTrigger = $('[data-nav-trigger]');
  if (navDropdown && navTrigger) {
    navTrigger.addEventListener('click', () => {
      const open = navDropdown.classList.toggle('is-open');
      navTrigger.setAttribute('aria-expanded', String(open));
    });
  }

  const cartOverlay = $('[data-cart-overlay]');
  const cartBody = $('[data-cart-drawer-body]');
  const cartFooter = $('[data-cart-drawer-footer]');

  const updateCartCount = (count) => {
    $$('[data-cart-count]').forEach((bubble) => {
      bubble.textContent = count;
      bubble.classList.toggle('is-empty', count === 0);
      const parent = bubble.closest('[data-cart-open]');
      if (parent) parent.setAttribute('aria-label', `Cart, ${count} items`);
    });
  };

  const renderCart = (cart) => {
    updateCartCount(cart.item_count || 0);
    if (!cartBody || !cartFooter) return;
    if (!cart.items || !cart.items.length) {
      cartBody.innerHTML = '<div class="drawer-empty"><div class="drawer-empty__mark">UP</div><h3>Your cart is empty</h3><p>Browse the catalog and add something worth keeping.</p><a class="button" href="/collections/all">Shop products</a></div>';
      cartFooter.classList.add('is-hidden');
      return;
    }
    cartBody.innerHTML = cart.items.map((item) => {
      const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
      return `<div class="drawer-line" data-cart-line="${escapeHtml(item.key)}"><a class="drawer-line__image" href="${escapeHtml(item.url)}">${image ? `<img src="${escapeHtml(sizedImage(image, 220))}" alt="">` : ''}</a><div class="drawer-line__info"><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title || item.title)}</strong></a>${variant}<div class="drawer-line__bottom"><span>${formatMoney(item.final_line_price || item.line_price)}</span><div class="drawer-line__controls"><button type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="Decrease ${escapeHtml(item.product_title || item.title)} quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity+1}" aria-label="Increase ${escapeHtml(item.product_title || item.title)} quantity">+</button><button class="drawer-line__remove" type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0">Remove</button></div></div></div></div>`;
    }).join('');
    cartFooter.classList.remove('is-hidden');
    const total = $('[data-cart-total]', cartFooter);
    if (total) total.textContent = formatMoney(cart.total_price);
    const shippingProgress = $('[data-shipping-progress]', cartFooter);
    if (shippingProgress) {
      const threshold = Number(shippingProgress.dataset.threshold || 7000);
      const remaining = Math.max(0, threshold - cart.total_price);
      const message = $('[data-shipping-message]', shippingProgress);
      const bar = $('[data-shipping-bar]', shippingProgress);
      if (message) message.textContent = remaining > 0 ? formatMoney(remaining) + ' away from free shipping.' : 'Free shipping unlocked.';
      if (bar) {
        bar.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
        if (bar.parentElement) bar.parentElement.setAttribute('aria-valuenow', String(Math.min(70, Math.round(cart.total_price / 100))));
      }
    }
  };

  const refreshCart = async () => {
    const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const changeCartLine = async (key, quantity, button) => {
    if (!key) return;
    const original = button ? button.innerHTML : '';
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${root}cart/change.js`, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:key, quantity:Number(quantity)})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to update cart.');
      renderCart(data);
      showToast(Number(quantity) === 0 ? 'Removed from cart.' : 'Cart updated.');
    } catch (error) {
      showToast(error.message || 'Unable to update cart.');
      if (button) { button.disabled = false; button.innerHTML = original; }
    }
  };

  $$('[data-cart-open]').forEach((link) => link.addEventListener('click', async (event) => {
    event.preventDefault();
    toggleLayer(cartOverlay, true);
    try { await refreshCart(); } catch (error) { /* page-rendered cart remains */ }
  }));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', () => toggleLayer(cartOverlay, false)));

  const ajaxAdd = async (form, button) => {
    const original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = '<span>Adding…</span>'; }
    try {
      const response = await fetch(`${root}cart/add.js`, {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this item.');
      await refreshCart();
      showToast('Added to cart.');
      toggleLayer(cartOverlay, true);
    } catch (error) {
      showToast(error.message || 'Unable to add this item.');
    } finally {
      if (button) { button.disabled = false; button.innerHTML = original; }
    }
  };

  const initAjaxForms = (scope = document) => {
    $$('.quick-add-form,.product-purchase-form', scope).forEach((form) => {
      if (form.dataset.ajaxReady === 'true') return;
      form.dataset.ajaxReady = 'true';
      form.addEventListener('submit', (event) => {
        const button = event.submitter || $('button[type="submit"]', form);
        if (!button) return;
        event.preventDefault();
        ajaxAdd(form, button);
      });
    });
  };
  initAjaxForms();

  $$('[data-product-thumb]').forEach((button) => button.addEventListener('click', () => {
    const gallery = button.closest('.product-gallery');
    const stageImage = gallery ? $('.product-stage img', gallery) : null;
    if (!stageImage || !button.dataset.image) return;
    stageImage.src = button.dataset.image;
    stageImage.alt = button.dataset.imageAlt || stageImage.alt;
    stageImage.removeAttribute('srcset');
    $$('[data-product-thumb]', gallery).forEach((thumb) => thumb.classList.remove('is-active'));
    button.classList.add('is-active');
    const lightboxImage = $('[data-lightbox-image]');
    if (lightboxImage) { lightboxImage.src = button.dataset.image; lightboxImage.alt = button.dataset.imageAlt || ''; }
  }));

  $$('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const rootEl = select.closest('[data-product-root]');
    const option = select.options[select.selectedIndex];
    if (!rootEl || !option) return;
    const currentPrice = $('[data-current-price]', rootEl);
    const comparePrice = $('[data-compare-price]', rootEl);
    const addButton = $('[data-add-button]', rootEl);
    const addLabel = $('[data-add-label]', rootEl);
    const mobilePrice = $('[data-mobile-price]');
    const mobileAdd = $('[data-mobile-add]');
    const available = option.dataset.available === 'true';
    const compare = option.dataset.compare || '';
    if (currentPrice) { currentPrice.textContent = option.dataset.price || ''; currentPrice.classList.toggle('price__sale', Boolean(compare)); }
    if (comparePrice) { comparePrice.textContent = compare; comparePrice.hidden = !compare; }
    if (mobilePrice) mobilePrice.textContent = option.dataset.price || '';
    if (addButton) addButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    if (mobileAdd) { mobileAdd.disabled = !available; mobileAdd.textContent = available ? 'Add to cart' : 'Sold out'; }
    if (option.dataset.image) {
      const stage = $('.product-stage img', rootEl);
      if (stage) { stage.src = option.dataset.image; stage.alt = option.dataset.imageAlt || stage.alt; stage.removeAttribute('srcset'); }
      const lightboxImage = $('[data-lightbox-image]');
      if (lightboxImage) { lightboxImage.src = option.dataset.image; lightboxImage.alt = option.dataset.imageAlt || ''; }
    }
    const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
  }));

  $$('[data-quantity-stepper]').forEach((stepper) => {
    const input = $('input', stepper);
    $('[data-qty-minus]', stepper)?.addEventListener('click', () => { if (input) input.value = Math.max(1, Number(input.value || 1) - 1); });
    $('[data-qty-plus]', stepper)?.addEventListener('click', () => { if (input) input.value = Math.max(1, Number(input.value || 1) + 1); });
  });

  const productLightbox = $('[data-product-lightbox]');
  $('[data-product-zoom]')?.addEventListener('click', () => toggleLayer(productLightbox, true));
  $$('[data-lightbox-close]').forEach((button) => button.addEventListener('click', () => toggleLayer(productLightbox, false)));

  const mobilePurchase = $('[data-mobile-purchase]');
  const mainAddButton = $('[data-add-button]');
  $('[data-mobile-add]')?.addEventListener('click', () => mainAddButton?.click());
  if (mobilePurchase && mainAddButton && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => mobilePurchase.classList.toggle('is-visible', !entry.isIntersecting), {threshold:.15});
    observer.observe(mainAddButton);
  }

  $$('[data-sort-by]').forEach((select) => select.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); window.location.assign(url.toString());
  }));

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); revealObserver.unobserve(entry.target); }
    }), {rootMargin:'0px 0px -6% 0px', threshold:.08});
    $$('[data-reveal]').forEach((el) => revealObserver.observe(el));
  } else {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
  }


  // Recently viewed products — stored locally in the shopper's browser.
  const currentProductData = $('[data-current-product-card]');
  const recentSection = $('[data-recently-viewed-section]');
  const recentGrid = $('[data-recently-viewed-grid]');
  if (currentProductData) {
    try {
      const current = JSON.parse(currentProductData.textContent);
      const key = 'undead-pulls-recent-products';
      const previous = JSON.parse(localStorage.getItem(key) || '[]');
      const deduped = previous.filter((item) => item && item.handle !== current.handle);
      if (recentSection && recentGrid && deduped.length) {
        recentGrid.innerHTML = deduped.slice(0,4).map((item) => `
          <a class="recent-card" href="${escapeHtml(item.url || '#')}">
            <span class="recent-card__media">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}</span>
            <span class="recent-card__copy"><small>${escapeHtml(item.meta || 'Undead Pulls TCG')}</small><strong>${escapeHtml(item.title || '')}</strong><span>${escapeHtml(item.price || '')}</span></span>
          </a>`).join('');
        recentSection.hidden = false;
      }
      localStorage.setItem(key, JSON.stringify([current, ...deduped].slice(0,8)));
    } catch (error) { /* recently viewed is optional */ }
  }



  // ------------------------------------------------------------
  // Collector Edition interaction layer
  // ------------------------------------------------------------
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(pointer:fine)').matches;

  // Scroll progress + premium sticky-header state.
  const pageProgress = $('[data-page-progress]');
  const siteHeader = $('[data-site-header]');
  let scrollFrame = null;
  const updateScrollUI = () => {
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, window.scrollY / max));
    if (pageProgress) pageProgress.style.transform = `scaleX(${progress})`;
    siteHeader?.classList.toggle('is-scrolled', window.scrollY > 18);
    scrollFrame = null;
  };
  window.addEventListener('scroll', () => {
    if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScrollUI);
  }, {passive:true});
  updateScrollUI();

  // A restrained cursor-reactive ambient glow. Disabled for touch/reduced motion.
  if (cfg.enableAmbientMotion && finePointer && !prefersReducedMotion) {
    let pointerFrame = null;
    let nextX = window.innerWidth * .5;
    let nextY = window.innerHeight * .3;
    window.addEventListener('pointermove', (event) => {
      nextX = event.clientX; nextY = event.clientY;
      if (pointerFrame) return;
      pointerFrame = requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--pointer-x', `${nextX}px`);
        document.documentElement.style.setProperty('--pointer-y', `${nextY}px`);
        pointerFrame = null;
      });
    }, {passive:true});
  }

  const initTiltCards = (scope = document) => {
    if (!cfg.enableTilt || !finePointer || prefersReducedMotion) return;
    $$('[data-tilt-card]', scope).forEach((card) => {
      if (card.dataset.tiltReady === 'true') return;
      card.dataset.tiltReady = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const px = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        const py = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
        card.style.setProperty('--tilt-x', `${((.5 - py) * 5.5).toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${((px - .5) * 6.5).toFixed(2)}deg`);
        card.style.setProperty('--shine-x', `${(px * 100).toFixed(1)}%`);
        card.style.setProperty('--shine-y', `${(py * 100).toFixed(1)}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
        card.style.setProperty('--shine-x', '50%');
        card.style.setProperty('--shine-y', '50%');
      });
    });
  };

  const initParallaxCards = (scope = document) => {
    if (!finePointer || prefersReducedMotion) return;
    $$('[data-ambient-card]', scope).forEach((card) => {
      if (card.dataset.parallaxReady === 'true') return;
      card.dataset.parallaxReady = 'true';
      const layers = $$('[data-parallax-layer]', card);
      if (!layers.length) return;
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) - .5;
        const y = ((event.clientY - rect.top) / rect.height) - .5;
        layers.forEach((layer) => {
          const strength = Number(layer.dataset.parallaxStrength || 8);
          layer.style.setProperty('--parallax-x', `${(x * strength).toFixed(2)}px`);
          layer.style.setProperty('--parallax-y', `${(y * strength).toFixed(2)}px`);
        });
      });
      card.addEventListener('pointerleave', () => layers.forEach((layer) => {
        layer.style.setProperty('--parallax-x', '0px');
        layer.style.setProperty('--parallax-y', '0px');
      }));
    });
  };

  // Local-device wishlist: fast, private, no account or app dependency.
  const WISHLIST_KEY = 'undead-pulls-wishlist-v1';
  const wishlistOverlay = $('[data-wishlist-overlay]');
  const wishlistBody = $('[data-wishlist-body]');
  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]').filter(Boolean); }
    catch (error) { return []; }
  };
  const writeWishlist = (items) => {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items.slice(0, 100))); }
    catch (error) { /* storage can be blocked without affecting shopping */ }
  };
  const syncWishlistUI = () => {
    const items = readWishlist();
    const handles = new Set(items.map((item) => item.handle));
    $$('[data-wishlist-count]').forEach((count) => {
      count.textContent = items.length;
      count.classList.toggle('is-empty', items.length === 0);
    });
    $$('[data-product-card]').forEach((card) => {
      const saved = handles.has(card.dataset.productHandle);
      const button = $('[data-wishlist-toggle]', card);
      if (!button) return;
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${card.dataset.productTitle || 'product'} ${saved ? 'from' : 'to'} favorites`);
      const label = $('span:not(.visually-hidden)', button);
      if (label && button.classList.contains('product-save-button')) label.textContent = saved ? 'Saved to favorites' : 'Save to favorites';
    });
  };
  const renderWishlist = () => {
    if (!wishlistBody) return;
    const items = readWishlist();
    if (!items.length) {
      wishlistBody.innerHTML = `<div class="drawer-empty wishlist-empty"><div class="drawer-empty__mark">♡</div><h3>Nothing saved yet.</h3><p>Tap the heart on anything you want to come back to.</p><a class="button" href="${escapeHtml(cfg.allProductsUrl || '/collections/all')}">Browse products</a></div>`;
      return;
    }
    wishlistBody.innerHTML = `<div class="wishlist-list">${items.map((item) => `
      <article class="wishlist-line" data-wishlist-line="${escapeHtml(item.handle)}">
        <a class="wishlist-line__media" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}</a>
        <div class="wishlist-line__copy"><small>Saved item</small><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.title)}</strong></a><span>${escapeHtml(item.price || '')}</span></div>
        <button type="button" class="wishlist-line__remove" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="Remove ${escapeHtml(item.title)} from favorites">×</button>
      </article>`).join('')}</div>`;
  };
  const openWishlist = () => { renderWishlist(); toggleLayer(wishlistOverlay, true); };
  $$('[data-wishlist-open]').forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); openWishlist(); }));
  $$('[data-wishlist-close]').forEach((button) => button.addEventListener('click', () => toggleLayer(wishlistOverlay, false)));
  syncWishlistUI();

  // Quick view uses Shopify's locale-aware Ajax product endpoint.
  const quickViewOverlay = $('[data-quick-view-overlay]');
  const quickViewBody = $('[data-quick-view-body]');
  const renderQuickView = (product) => {
    if (!quickViewBody) return;
    const images = Array.isArray(product.images) ? product.images : [];
    const featured = product.featured_image || images[0] || '';
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const availableVariant = variants.find((variant) => variant.available) || variants[0];
    const handle = product.handle || '';
    const url = `${root}products/${encodeURIComponent(handle)}`;
    quickViewBody.innerHTML = `
      <div class="quick-view-grid">
        <div class="quick-view-gallery">
          <div class="quick-view-stage">${featured ? `<img src="${escapeHtml(sizedImage(featured, 1100))}" data-qv-main-image alt="${escapeHtml(product.title || '')}">` : ''}</div>
          ${images.length > 1 ? `<div class="quick-view-thumbs">${images.slice(0,5).map((image, index) => `<button type="button" data-qv-thumb data-image="${escapeHtml(image)}" class="${index===0?'is-active':''}"><img src="${escapeHtml(sizedImage(image, 160))}" alt=""></button>`).join('')}</div>` : ''}
        </div>
        <div class="quick-view-copy">
          <span class="micro-label">${escapeHtml(product.type || product.vendor || 'Undead Pulls TCG')}</span>
          <h2>${escapeHtml(product.title || '')}</h2>
          <div class="quick-view-price" data-qv-price>${formatMoney(availableVariant ? availableVariant.price : product.price)}</div>
          ${variants.length > 1 ? `<label class="field-label" for="QuickViewVariant">Choose option</label><select id="QuickViewVariant" class="variant-select" name="id" data-qv-variant>${variants.map((variant) => `<option value="${variant.id}" data-price="${variant.price}" data-available="${variant.available}" ${variant.available?'':'disabled'} ${availableVariant && variant.id===availableVariant.id?'selected':''}>${escapeHtml(variant.title)} — ${formatMoney(variant.price)}${variant.available?'':' — Sold out'}</option>`).join('')}</select>` : ''}
          <form class="quick-view-form" data-qv-form>
            <input type="hidden" name="id" data-qv-id value="${availableVariant ? availableVariant.id : ''}">
            <div class="purchase-row"><div class="quantity-stepper" data-quantity-stepper><button type="button" data-qty-minus aria-label="Decrease quantity">−</button><input name="quantity" type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-qty-plus aria-label="Increase quantity">+</button></div><button class="button button--purchase" type="submit" data-qv-add ${availableVariant && availableVariant.available ? '' : 'disabled'}><span>${availableVariant && availableVariant.available ? 'Add to cart' : 'Sold out'}</span><span aria-hidden="true">→</span></button></div>
          </form>
          <div class="quick-view-actions"><button type="button" class="text-button" data-qv-save data-handle="${escapeHtml(handle)}">♡ Save for later</button><a class="text-link" href="${escapeHtml(url)}">View full details →</a></div>
          <div class="quick-view-note"><span>Fast view</span><p>Open the full product page for complete condition notes, additional media, metafields, and app content.</p></div>
        </div>
      </div>`;
    const variantSelect = $('[data-qv-variant]', quickViewBody);
    const hiddenId = $('[data-qv-id]', quickViewBody);
    const addButton = $('[data-qv-add]', quickViewBody);
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      if (hiddenId) hiddenId.value = option.value;
      $('[data-qv-price]', quickViewBody).textContent = formatMoney(option.dataset.price);
      if (addButton) addButton.disabled = option.dataset.available !== 'true';
    });
    $$('[data-qv-thumb]', quickViewBody).forEach((button) => button.addEventListener('click', () => {
      const main = $('[data-qv-main-image]', quickViewBody);
      if (main && button.dataset.image) main.src = sizedImage(button.dataset.image, 1100);
      $$('[data-qv-thumb]', quickViewBody).forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    }));
    $$('[data-quantity-stepper]', quickViewBody).forEach((stepper) => {
      const input = $('input', stepper);
      $('[data-qty-minus]', stepper)?.addEventListener('click', () => { if (input) input.value = Math.max(1, Number(input.value || 1) - 1); });
      $('[data-qty-plus]', stepper)?.addEventListener('click', () => { if (input) input.value = Math.max(1, Number(input.value || 1) + 1); });
    });
    $('[data-qv-form]', quickViewBody)?.addEventListener('submit', (event) => {
      event.preventDefault();
      const button = event.submitter || $('[data-qv-add]', quickViewBody);
      ajaxAdd(event.currentTarget, button).then(() => toggleLayer(quickViewOverlay, false));
    });
    $('[data-qv-save]', quickViewBody)?.addEventListener('click', () => {
      const source = document.querySelector(`[data-product-card][data-product-handle="${CSS.escape(handle)}"]`);
      let items = readWishlist();
      if (items.some((item) => item.handle === handle)) {
        items = items.filter((item) => item.handle !== handle);
        showToast('Removed from favorites.');
      } else {
        items.unshift({handle, title:product.title || '', url, image:featured ? sizedImage(featured,620) : '', price:formatMoney(availableVariant ? availableVariant.price : product.price)});
        showToast('Saved to favorites.');
      }
      writeWishlist(items); syncWishlistUI(); renderWishlist();
      if (source) syncWishlistUI();
    });
  };
  const openQuickView = async (handle) => {
    if (!quickViewOverlay || !quickViewBody || !handle) return;
    quickViewBody.innerHTML = '<div class="quick-view-loading"><span class="loader-orb"></span><strong>Loading product</strong><small>One second…</small></div>';
    toggleLayer(quickViewOverlay, true);
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Product could not be loaded.');
      renderQuickView(await response.json());
    } catch (error) {
      quickViewBody.innerHTML = `<div class="quick-view-loading"><strong>Couldn’t open quick view.</strong><small>${escapeHtml(error.message || 'Open the product page to continue.')}</small><a class="button button--small" href="${root}products/${encodeURIComponent(handle)}">Open product</a></div>`;
    }
  };
  $$('[data-quick-view-close]').forEach((button) => button.addEventListener('click', () => toggleLayer(quickViewOverlay, false)));

  // Shopify-native product recommendations, loaded only when needed.
  const initRecommendations = (scope = document) => {
    $$('[data-recommendations-section]', scope).forEach((section) => {
      if (section.dataset.recommendationsReady === 'true') return;
      const url = section.dataset.recommendationsUrl;
      if (!url) return;
      section.dataset.recommendationsReady='true';
      fetch(url, {headers:{Accept:'text/html'}})
        .then((response) => response.ok ? response.text() : '')
        .then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html,'text/html');
          const incoming = $('[data-recommendations-section]', doc);
          if (!incoming || !incoming.innerHTML.trim()) return;
          section.innerHTML = incoming.innerHTML;
          section.hidden = incoming.hidden;
          if (!section.hidden) { initAjaxForms(section); initTiltCards(section); syncWishlistUI(); }
        })
        .catch(() => { /* Recommendations are enhancement-only. */ });
    });
  };

  // Countdown sections can be reused for drops, live shows, restocks, and launches.
  const initCountdowns = (scope = document) => {
    $$('[data-countdown]', scope).forEach((clock) => {
      if (clock.dataset.countdownReady === 'true') return;
      const target = Date.parse(clock.dataset.countdown || '');
      if (!Number.isFinite(target)) return;
      clock.dataset.countdownReady = 'true';
      const section = clock.closest('[data-countdown-section]');
      const status = section ? $('[data-countdown-status]', section) : null;
      const update = () => {
        const diff = target - Date.now();
        if (diff <= 0) {
          $('[data-days]', clock).textContent='00'; $('[data-hours]', clock).textContent='00'; $('[data-minutes]', clock).textContent='00'; $('[data-seconds]', clock).textContent='00';
          clock.classList.add('is-live');
          if (status) status.textContent='The drop is live now.';
          clearInterval(clock._timer); return;
        }
        const seconds = Math.floor(diff/1000);
        $('[data-days]', clock).textContent=String(Math.floor(seconds/86400)).padStart(2,'0');
        $('[data-hours]', clock).textContent=String(Math.floor((seconds%86400)/3600)).padStart(2,'0');
        $('[data-minutes]', clock).textContent=String(Math.floor((seconds%3600)/60)).padStart(2,'0');
        $('[data-seconds]', clock).textContent=String(seconds%60).padStart(2,'0');
      };
      update(); clock._timer=setInterval(update,1000);
    });
  };

  // Instant-switch curated shelves.
  const initCollectorPortals = (scope = document) => {
    $$('[data-collector-portal]', scope).forEach((portal) => {
      if (portal.dataset.portalReady === 'true') return;
      portal.dataset.portalReady='true';
      $$('[data-collector-tab]', portal).forEach((tab) => tab.addEventListener('click', () => {
        const id = tab.dataset.collectorTab;
        $$('[data-collector-tab]', portal).forEach((candidate) => { const active=candidate===tab; candidate.classList.toggle('is-active',active); candidate.setAttribute('aria-selected',String(active)); });
        $$('[data-collector-panel]', portal).forEach((panel) => { const active=panel.dataset.collectorPanel===id; panel.hidden=!active; panel.classList.toggle('is-active',active); });
        initTiltCards(portal); syncWishlistUI();
      }));
    });
  };

  // Progressive collection loading. Pagination remains as the no-JS fallback.
  const initLoadMore = (scope = document) => {
    $$('[data-load-more]', scope).forEach((button) => {
      if (button.dataset.loadMoreReady === 'true') return;
      button.dataset.loadMoreReady='true';
      button.addEventListener('click', async () => {
        const url = button.dataset.nextUrl;
        if (!url) return;
        const original = button.textContent;
        button.disabled=true; button.textContent='Loading more…';
        try {
          const response = await fetch(url, {headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Could not load more products.');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const incoming = $('[data-collection-grid]', doc);
          const current = $('[data-collection-grid]');
          if (!incoming || !current) throw new Error('Product grid was not found.');
          Array.from(incoming.children).forEach((child) => current.appendChild(child));
          const nextButton = $('[data-load-more]', doc);
          if (nextButton?.dataset.nextUrl) button.dataset.nextUrl=nextButton.dataset.nextUrl;
          else button.remove();
          initAjaxForms(current); initTiltCards(current); syncWishlistUI();
          showToast('More products loaded.');
        } catch (error) { showToast(error.message || 'Unable to load more products.'); button.disabled=false; button.textContent=original; return; }
        if (button.isConnected) { button.disabled=false; button.textContent=original; }
      });
    });
  };

  document.addEventListener('click', (event) => {
    const cartChangeButton = event.target.closest('[data-cart-change]');
    if (cartChangeButton) { event.preventDefault(); changeCartLine(cartChangeButton.dataset.key, cartChangeButton.dataset.quantity, cartChangeButton); return; }
    const favoriteButton = event.target.closest('[data-wishlist-toggle]');
    if (favoriteButton) {
      event.preventDefault(); event.stopPropagation();
      const card = favoriteButton.closest('[data-product-card]');
      if (!card) return;
      let items=readWishlist(); const handle=card.dataset.productHandle;
      if (items.some((item)=>item.handle===handle)) { items=items.filter((item)=>item.handle!==handle); showToast('Removed from favorites.'); }
      else { items.unshift({handle,title:card.dataset.productTitle || '',url:card.dataset.productUrl || '#',image:card.dataset.productImage || '',price:card.dataset.productPrice || ''}); showToast('Saved to favorites.'); }
      writeWishlist(items); syncWishlistUI(); renderWishlist(); return;
    }
    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault(); writeWishlist(readWishlist().filter((item)=>item.handle!==removeButton.dataset.wishlistRemove)); renderWishlist(); syncWishlistUI(); return;
    }
    const quickButton = event.target.closest('[data-quick-view]');
    if (quickButton) { event.preventDefault(); event.stopPropagation(); openQuickView(quickButton.dataset.handle); }
  });

  const initCollectorEdition = (scope = document) => {
    initAjaxForms(scope); initTiltCards(scope); initParallaxCards(scope); initRecommendations(scope); initCountdowns(scope); initCollectorPortals(scope); initLoadMore(scope); syncWishlistUI();
  };
  initCollectorEdition();
  document.addEventListener('shopify:section:load', (event) => initCollectorEdition(event.target));
  document.addEventListener('click', (event) => {
    if (navDropdown && !navDropdown.contains(event.target)) { navDropdown.classList.remove('is-open'); navTrigger?.setAttribute('aria-expanded','false'); }
    if (mobileMenu?.classList.contains('is-open') && !mobileMenu.contains(event.target) && !mobileButton?.contains(event.target)) {
      mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden','true'); mobileButton?.setAttribute('aria-expanded','false');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    toggleLayer(searchOverlay, false); toggleLayer(cartOverlay, false); toggleLayer(productLightbox, false); toggleLayer(wishlistOverlay, false); toggleLayer(quickViewOverlay, false);
    if (mobileMenu) { mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden','true'); }
    mobileButton?.setAttribute('aria-expanded','false');
    navDropdown?.classList.remove('is-open'); navTrigger?.setAttribute('aria-expanded','false');
  });
})();
